import { getApiInst } from '~/atoms/MangoApi'

import { createPbxSettingsApi } from '@mangovoice/pbx-settings-ui'

export const pbxSettingsApi = createPbxSettingsApi(
  getApiInst().getHttpTransport(),
)
